import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Text, Button } from '@simplybenefits/sb-ui-library';
import permissionLevel from '../../services/permissions.js';
import ClaimBlock from '../Adjudication/components/ClaimBlock.js';

class Claims extends PureComponent {
    state = {
        selectedClaimID: null
    };

    componentWillUnmount() {
        // Clean up the filters in redux
        if (this.props.amountOfActiveFilters) {
            this.props.resetFilters();
        }
    }

    render() {
        const { claims, meta } = this.props;
        const claimsBlocked = meta.accountClaimsBlocked || meta.divisionClaimsBlocked || meta.memberClaimsBlocked;
        let adjudicators = [];

        if (permissionLevel('Reassign Claim', this.props.accessType).includes('write')) {
            adjudicators = [ 'All', 'Unassigned' ];

            this.props.adjudicators.map((item) => {
                adjudicators.push(`${ item.firstname } ${ item.lastname }`);
                return null;
            });
        }

        return (
            <div>
                <Text mediumLarge bold margin="0 0 10px 0" >Total Claims</Text>
                {
                    claims.length === 0 && this.props.amountOfActiveFilters !== 0 ?
                        <div>
                            <Text mediumLarge>No results found. <span onClick={ this.props.resetFilters } style={{ textDecoration: 'underline', cursor: 'pointer' }}>Clear Filters</span></Text>
                        </div>
                        :
                        <>
                            <ClaimBlock isHeader access={ this.props.accessType } />

                            {
                                claims.length === 0 ?
                                    <Text bold medium>No claims yet for this user.</Text>
                                    :
                                    claims.map((claim, i) => (
                                        <ClaimBlock
                                            testid={i === 0 && "claimblock"}
                                            key={claim.claimID}
                                            claimID={claim.claimID}
                                            uid={claim.uid}
                                            user={claim.name}
                                            benefit={claim.benefit}
                                            submitted={Number(claim.amountSubmitted)}
                                            claimed={Number(claim.amountPaid)}
                                            assignedTo={claim.assignedTo}
                                            status={claim.status}
                                            serviceDate={ claim.serviceDate }
                                            submissionDate={ claim.dateAdded }
                                            type={claim.type}
                                            claimType={claim.claimType}
                                            userID={meta.userID}
                                            access={ this.props.accessType }
                                            adjudicators={ adjudicators }
                                            cert={meta.cert}
                                            claimBlocked={claimsBlocked}
                                        />
                                    ))
                            }

                            {
                                claims.length > 9 && // Greater than 9 since we don't want to show the button if there aren't more claims to load (Initial load is 10)
                                this.props.cursor >= 0 &&
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button
                                            onClick={ this.props.loadMore }
                                            color="primary"
                                            marginTop={2}
                                        >
                                            Load More
                                        </Button>
                                    </div>
                            }
                        </>
                }

                <span id="user-claim" />
            </div>
        );
    }
}

Claims.propTypes = {
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accessType: state.master.access,
    adjudicators: state.master.adjudicators,
    cursor: state.users.currentUser.claimsCursor
});

export default connect(mapStateToProps)(Claims);